import { Exception } from './exception';

export class IllegalArgumentException extends Exception {}
